import {ClientMetadataRepository} from "domain/ports/ClientMetadataRepository";
import {ClientMetadataResponse} from "domain/types/clientMetadataTypes";

export class ClientMetadataService {
    constructor(private repository: ClientMetadataRepository) {
    }

    async getClientMetadata(campaignId: string): Promise<ClientMetadataResponse> {
        return await this.repository.getData(campaignId);
    }
}